
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/0cfd59917bf6d9fd5d310c0650be524a/f8ab8bcec9a7e9922eda1fb6f34845be.png" 
              alt="Langfeldt Mechanical LLC - Refrigeration, Heating, Cooling" 
              className="h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer">
              Home
            </Link>
            
            {/* Services Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button className="text-gray-700 hover:text-red-600 font-medium transition-colors flex items-center gap-1 cursor-pointer">
                Services
                <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2">
                  <Link 
                    to="/services" 
                    className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer"
                  >
                    All Services
                  </Link>
                  <Link 
                    to="/services/heating" 
                    className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer"
                  >
                    Heating
                  </Link>
                  <Link 
                    to="/services/cooling" 
                    className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer"
                  >
                    Cooling
                  </Link>
                  <Link 
                    to="/services/commercial-refrigeration" 
                    className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer"
                  >
                    Commercial Refrigeration
                  </Link>
                  <Link 
                    to="/emergency-service" 
                    className="block px-4 py-2 text-red-600 hover:bg-red-50 font-semibold transition-colors cursor-pointer"
                  >
                    Emergency Service
                  </Link>
                </div>
              )}
            </div>

            <Link to="/service-areas" className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer">
              Service Areas
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer">
              About
            </Link>
            <Link to="/reviews" className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer">
              Reviews
            </Link>
            <Link to="/faq" className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer">
              FAQ
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer">
              Contact
            </Link>
          </nav>

          {/* Phone CTA */}
          <a 
            href="tel:2313988023" 
            className="hidden lg:inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-6 py-3 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            <span>(231) 398-8023</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-red-600 cursor-pointer"
          >
            <i className={`text-3xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-2">
              <Link 
                to="/" 
                className="px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/services" 
                className="px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link 
                to="/services/heating" 
                className="px-4 py-2 pl-8 text-gray-600 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors text-sm cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Heating
              </Link>
              <Link 
                to="/services/cooling" 
                className="px-4 py-2 pl-8 text-gray-600 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors text-sm cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Cooling
              </Link>
              <Link 
                to="/services/commercial-refrigeration" 
                className="px-4 py-2 pl-8 text-gray-600 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors text-sm cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Commercial Refrigeration
              </Link>
              <Link 
                to="/emergency-service" 
                className="px-4 py-2 text-red-600 hover:bg-red-50 font-semibold rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Emergency Service
              </Link>
              <Link 
                to="/service-areas" 
                className="px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Service Areas
              </Link>
              <Link 
                to="/about" 
                className="px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/reviews" 
                className="px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Reviews
              </Link>
              <Link 
                to="/faq" 
                className="px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                FAQ
              </Link>
              <Link 
                to="/contact" 
                className="px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <a 
                href="tel:2313988023" 
                className="mx-4 mt-2 inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-6 py-3 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                <span>(231) 398-8023</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
